import { HeaderLightTemplate } from "./templates/header-light";
import { HeaderMyTrumpfTemplate } from "./templates/header-mytrumpf";
import { HeaderWebsiteTemplate } from "./templates/header-website";

export default {
    title: "Shared/Header",
    component: "ux-iws-header",
    args: {
        withToolbox: true,
        withBreadcrumb: false,
        type: "website",
        is100Years: false,
    },
    argTypes: {
        withToolbox: { control: "boolean" },
        withBreadcrumb: { control: "boolean" },
        type: { control: { type: "radio" }, options: ["website", "mytrumpf"] },
        is100Years: { control: "boolean" },
    },
};

export const HeaderLight = HeaderLightTemplate.bind({});
HeaderLight.args = {
    type: "mytrumpf",
};
HeaderLight.argTypes = {
    type: {
        control: { type: "radio" },
        options: ["website", "mytrumpf"],
    },
};

export const HeaderMyTrumpf = HeaderMyTrumpfTemplate.bind({});
HeaderMyTrumpf.args = {
    type: "mytrumpf",
};
HeaderMyTrumpf.argTypes = {
    type: {
        control: { type: "radio" },
        options: ["website", "mytrumpf"],
    },
};
HeaderMyTrumpf.parameters = {
    design: {
        type: "figma",
        url: "https://www.figma.com/file/VCrRUWZMXaM7x7FBa3zq7H/Lib_Web-Styleguide-2.0?type=design&node-id=4455%3A6479&mode=design&t=COX0i0LK2IwN77A0-1",
    },
};

export const HeaderWebsite = HeaderWebsiteTemplate.bind({});
